// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"763c0310","402":"9231a0a3","418":"5a63e56c","453":"5540a973","593":"b0a3b882","852":"9e558352","856":"18d29028","961":"325af462"}[chunkId] + ".chunk.js";
};